// --- API Configuration ---

// Vite will automatically load the correct .env file (.env.production, .env.staging, etc.)
// based on the build mode and set the value of VITE_API_BASE_URL.
// This is now the single source of truth for our API endpoint.
// Make sure you have a .env.production and a .env.staging file.
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;


// --- Other Constants ---
export const POLLING_INTERVAL = 7000; // 7 seconds for polling updates

// Mock names, likely used as placeholders in the UI
export const MOCK_OPERATOR_NAME = "Support Agent";
export const MOCK_BOT_NAME = "ChatBot";

// You can add other frontend-wide constants here
// export const SOME_OTHER_CONSTANT = "some_value";


// --- Verification Log ---
// This will log the correct URL based on the build mode.
// `import.meta.env.MODE` gives the name of the mode ('production', 'staging', 'development').
console.log(`[constants.ts] API_BASE_URL determined for mode '${import.meta.env.MODE}': ${API_BASE_URL}`);